// Theme: ocean
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'ocean',
  name: 'OCEAN',
  tagline: 'OCEAN',
  description: 'Oceano profundo. Azul abissal com luz filtrada de superficie.',
  category: 'organic-world',
  tier: 'rare',
  basePrice: 1000,
  swatches: ['#03192E', '#0284C7', '#0A2A4A', '#BAE6FD'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '14px',
      '--shadow-card': '0 10px 28px rgba(2, 132, 199, 0.08)',
      '--shadow-card-active': '0 10px 28px rgba(2, 132, 199, 0.08)'
    },
    shellClasses: 'font-sans theme-ocean'
  },
  colorVars: {
    '--accent': '#0284C7',
    '--accent-foreground': '#03192E',
    '--background': '#03192E',
    '--border': '#1A5A8F',
    '--card': '#0A2A4A',
    '--card-border-active': 'rgba(2, 132, 199, 0.08)',
    '--card-completed': '#0E3257',
    '--card-foreground': '#BAE6FD',
    '--card-glow': 'rgba(2, 132, 199, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#03192E',
    '--foreground': '#BAE6FD',
    '--hold-fill': '#0284C7',
    '--input': '#0A2A4A',
    '--modal-bg': '#03192E',
    '--modal-border': '#1A5A8F',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(2, 132, 199, 0.08)',
    '--muted': '#0A2A4A',
    '--muted-foreground': '#7EC5EA',
    '--nav-active': '#0284C7',
    '--nav-bg': '#03192E',
    '--popover': '#0A2A4A',
    '--popover-foreground': '#BAE6FD',
    '--primary': '#0284C7',
    '--primary-foreground': '#03192E',
    '--ring': '#0284C7',
    '--secondary': '#1A5A8F',
    '--secondary-foreground': '#BAE6FD',
    '--streak': '#0284C7',
    '--success': '#22c55e',
    '--success-foreground': '#03192E',
    '--xp': '#0284C7',
    '--xp-bg': '#0A2A4A'
  },
  resolvedVars: {
    '--accent': '#0284C7',
    '--accent-foreground': '#03192E',
    '--accent-foreground-hsl': '209 88% 10%',
    '--accent-foreground-oklch': 'from #03192E l c h',
    '--accent-hsl': '200 98% 39%',
    '--accent-oklch': 'from #0284C7 l c h',
    '--background': '#03192E',
    '--background-hsl': '209 88% 10%',
    '--background-oklch': 'from #03192E l c h',
    '--border': '#1A5A8F',
    '--border-hsl': '207 69% 33%',
    '--border-oklch': 'from #1A5A8F l c h',
    '--border-w': '1px',
    '--card': '#0A2A4A',
    '--card-border-active': 'rgba(2, 132, 199, 0.08)',
    '--card-completed': '#0E3257',
    '--card-completed-hsl': '210 72% 20%',
    '--card-completed-oklch': 'from #0E3257 l c h',
    '--card-foreground': '#BAE6FD',
    '--card-foreground-hsl': '201 94% 86%',
    '--card-foreground-oklch': 'from #BAE6FD l c h',
    '--card-glow': 'rgba(2, 132, 199, 0.08)',
    '--card-hsl': '210 76% 16%',
    '--card-oklch': 'from #0A2A4A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#03192E',
    '--destructive-foreground-hsl': '209 88% 10%',
    '--destructive-foreground-oklch': 'from #03192E l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#BAE6FD',
    '--foreground-hsl': '201 94% 86%',
    '--foreground-oklch': 'from #BAE6FD l c h',
    '--hold-fill': '#0284C7',
    '--hold-fill-hsl': '200 98% 39%',
    '--hold-fill-oklch': 'from #0284C7 l c h',
    '--input': '#0A2A4A',
    '--input-hsl': '210 76% 16%',
    '--input-oklch': 'from #0A2A4A l c h',
    '--modal-bg': '#03192E',
    '--modal-bg-hsl': '209 88% 10%',
    '--modal-bg-oklch': 'from #03192E l c h',
    '--modal-border': '#1A5A8F',
    '--modal-border-hsl': '207 69% 33%',
    '--modal-border-oklch': 'from #1A5A8F l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(2, 132, 199, 0.08)',
    '--muted': '#0A2A4A',
    '--muted-foreground': '#7EC5EA',
    '--muted-foreground-hsl': '201 72% 71%',
    '--muted-foreground-oklch': 'from #7EC5EA l c h',
    '--muted-hsl': '210 76% 16%',
    '--muted-oklch': 'from #0A2A4A l c h',
    '--nav-active': '#0284C7',
    '--nav-active-hsl': '200 98% 39%',
    '--nav-active-oklch': 'from #0284C7 l c h',
    '--nav-bg': '#03192E',
    '--nav-bg-hsl': '209 88% 10%',
    '--nav-bg-oklch': 'from #03192E l c h',
    '--popover': '#0A2A4A',
    '--popover-foreground': '#BAE6FD',
    '--popover-foreground-hsl': '201 94% 86%',
    '--popover-foreground-oklch': 'from #BAE6FD l c h',
    '--popover-hsl': '210 76% 16%',
    '--popover-oklch': 'from #0A2A4A l c h',
    '--primary': '#0284C7',
    '--primary-foreground': '#03192E',
    '--primary-foreground-hsl': '209 88% 10%',
    '--primary-foreground-oklch': 'from #03192E l c h',
    '--primary-hsl': '200 98% 39%',
    '--primary-oklch': 'from #0284C7 l c h',
    '--radius': '14px',
    '--ring': '#0284C7',
    '--ring-hsl': '200 98% 39%',
    '--ring-oklch': 'from #0284C7 l c h',
    '--secondary': '#1A5A8F',
    '--secondary-foreground': '#BAE6FD',
    '--secondary-foreground-hsl': '201 94% 86%',
    '--secondary-foreground-oklch': 'from #BAE6FD l c h',
    '--secondary-hsl': '207 69% 33%',
    '--secondary-oklch': 'from #1A5A8F l c h',
    '--shadow-card': '0 10px 28px rgba(2, 132, 199, 0.08)',
    '--shadow-card-active': '0 10px 28px rgba(2, 132, 199, 0.08)',
    '--streak': '#0284C7',
    '--streak-hsl': '200 98% 39%',
    '--streak-oklch': 'from #0284C7 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#03192E',
    '--success-foreground-hsl': '209 88% 10%',
    '--success-foreground-oklch': 'from #03192E l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(200 98% 39% / 0.15)',
    '--xp': '#0284C7',
    '--xp-bg': '#0A2A4A',
    '--xp-bg-hsl': '210 76% 16%',
    '--xp-bg-oklch': 'from #0A2A4A l c h',
    '--xp-hsl': '200 98% 39%',
    '--xp-oklch': 'from #0284C7 l c h'
  }
}
